import { Page, PageTitle } from '../../../components';
import { isHomeowner } from '../../../helpers';
import { useContext } from 'react';
import { UserContext } from '../../../context';
import { MyBuildList } from './my-build-list';

export const MyBuild = () => {
  const { user } = useContext(UserContext);

  return (
    <Page title="My Builds" showSideNav={!isHomeowner(user)}>
      <PageTitle title="My Builds" />
      <MyBuildList />
    </Page>
  );
};
